import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel, trackCheckoutClicks, trackPixelEvent } from './utils/metaPixel';
import { CHECKOUT_URL, META_PIXEL_ID } from './data/product';
const productParams = {
  content_name: 'Halloween PE Ready',
  content_type: 'product',
  value: 19,
  currency: 'USD'
};
export function App() {
  useEffect(() => {
    // Load the pixel after the page has rendered so it doesn't slow down the first paint.
    let timer: number | undefined;
    const start = () => {
      timer = window.setTimeout(() => {
        initMetaPixel(META_PIXEL_ID);
        trackPixelEvent('ViewContent', productParams);
      }, 1500);
    };
    if (document.readyState === 'complete') start();else window.addEventListener('load', start, {
      once: true
    });
    const stopTracking = trackCheckoutClicks(CHECKOUT_URL, META_PIXEL_ID, productParams);
    return () => {
      window.removeEventListener('load', start);
      if (timer) window.clearTimeout(timer);
      stopTracking();
    };
  }, []);
  return <SalesPage data-id="element-0" data-mp="3ijpbavgxap74" />;
}